import translate from '@/utils/translate';

export default function invitedStatusText({
  invitedStatus,
  origination,
  dateLabel,
}: {
  invitedStatus?: string | null;
  origination?: string | null;
  dateLabel?: string | null;
}): string | null {
  if (invitedStatus === 'applied') {
    if (!dateLabel) {
      if (origination === 'off_platform_invite') {
        return translate('Applied via email invite');
      }
      return origination === 'direct_link'
        ? translate('Applied via share link')
        : translate('Applied');
    }
    if (origination === 'direct_link') {
      return translate('invited-applied-via-share-link-on-date', {
        date: dateLabel,
      });
    }
    if (origination === 'off_platform_invite') {
      return translate('invited-applied-via-email-invite-on-date', {
        date: dateLabel,
      });
    }
    return translate('invited-applied-on-date', {date: dateLabel});
  }

  if (invitedStatus === 'dismissed') {
    return translate('Creator dismissed');
  }

  return null;
}
